<script lang="ts" setup>
import UserAvatar from "@/components/UserAvatar.vue";
import { Popup, showLoadingToast } from "vant";
import i18n from "@/locales";
import { startChatSession } from "@/components/mobile/chat/chatUtils";
import { computed } from "vue";
import { useMate } from "@/stores/mate";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

//Props & Emit
const props = defineProps<{
  show: boolean;
}>();
const emit = defineEmits<{
  (event: "update:show", value: boolean): void;
}>();

// States
const mateStore = useMate();
const { currentMate } = storeToRefs(mateStore);
const route = useRoute();
const validChatMateList = computed(() => {
  return mateStore.list.filter(
    (item) => item.id !== currentMate.value!.id && item.status === 1
  );
});

// Event Handler
const onMateChatSelected = async (mateId: number) => {
  const toast = showLoadingToast({
    message: i18n.global.t("Message.snacksDuringChatPreparation"),
    duration: 0,
  });
  const targetMateId = currentMate.value!.id;
  const targetMateUuid = currentMate.value!.uuid;
  await mateStore.changeCurrentMate(mateId);
  toast.close();
  await startChatSession(targetMateId!, targetMateUuid);
  emit("update:show", false);
};
</script>
<template>
  <Popup
    :class="{
      'pb-20': route.meta.showBottomNav,
    }"
    :show="show"
    class="max-h-[80%] grid grid-rows-[auto_1fr] overflow-hidden"
    position="bottom"
    round
    @update:show="emit('update:show', $event)"
  >
    <div
      class="w-full flex items-center justify-center py-3 text-base-content border-b font-bold"
      v-html="$t('Chats.chooseCharacterToChat', { name: currentMate!.name })"
    />
    <div class="overflow-y-auto h-full">
      <div class="flex flex-col">
        <div
          v-for="mate in validChatMateList"
          :key="mate.id"
          class="flex p-4 items-center justify-between border-b cursor-pointer"
          @click="onMateChatSelected(mate.id!)"
        >
          <div class="flex items-center gap-4">
            <user-avatar :avatar-url="mate.mediaUrl" class="h-12" />
            <div v-if="mate.name">{{ mate.name }}</div>
          </div>
          <div class="flex gap-2 items-center">
            <button
              class="btn btn-sm rounded text-base-content/50 btn-ghost font-normal"
            >
              <i class="iconify mingcute--right-line" />
            </button>
          </div>
        </div>
        <div
          class="flex p-4 items-center justify-between border-b"
          @click="mateStore.clickCreateMate()"
        >
          <div class="flex items-center gap-4">
            <div class="flex items-center justify-center w-9 h-9 rounded-full">
              <plus-icon class="w-3 h-3 text-neutral" />
            </div>
            <div>{{ $t("Buttons.createNewCharacter") }}</div>
          </div>
        </div>
      </div>
    </div>
  </Popup>
</template>
